import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=266b05a5&scoped=true"
import script from "./CustomerProfile.vue?vue&type=script&lang=js"
export * from "./CustomerProfile.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfile.vue?vue&type=style&index=0&id=266b05a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266b05a5",
  null
  
)

export default component.exports